import SparkleIcon from 'assets/icons/sparkle.svg?react';
import './LoadingSparkles.scss';

const LoadingSparkles = ({ loadingText }: { loadingText?: string }) => {
  return (
    <div className="sparkles-loading" role="status" aria-live="polite" aria-busy="true">
      <div className="sparkles-wrapper" aria-hidden="true">
        <SparkleIcon className="sparkle sparkle-1" aria-hidden="true" focusable="false" />
        <SparkleIcon className="sparkle sparkle-2" aria-hidden="true" focusable="false" />
        <SparkleIcon className="sparkle sparkle-3" aria-hidden="true" focusable="false" />
      </div>
      <span className="dots">{loadingText}</span>
    </div>
  );
};

export default LoadingSparkles;
